// extracted by mini-css-extract-plugin
export const outerWrapper = "header-module--outerWrapper--3k9Xt";
export const wrapper = "header-module--wrapper--182n5";
export const intro = "header-module--intro--2g3hr";
export const intro_title = "header-module--intro_title--2jnhm";
export const meta = "header-module--meta--jHI0l";
export const meta_item = "header-module--meta_item--1dw6d";
export const meta_icon = "header-module--meta_icon--l-wcs";
export const meta_text = "header-module--meta_text--19Htw";